import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavIconConnections = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1283_17616)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M11.4406 4.31758C12.4059 4.09062 13.125 3.22383 13.125 2.1875C13.125 0.978906 12.1461 0 10.9375 0C9.75078 0 8.78555 0.943359 8.75 2.11914L3.72422 4.13164C3.32773 3.74063 2.78633 3.5 2.1875 3.5C0.978906 3.5 0 4.47891 0 5.6875C0 6.89609 0.978906 7.875 2.1875 7.875C2.52109 7.875 2.83828 7.80117 3.11992 7.66719L7.10117 11.1508C7.03555 11.3586 7 11.5828 7 11.8125C7 13.0211 7.97891 14 9.1875 14C10.3961 14 11.375 13.0211 11.375 11.8125C11.375 11.0551 10.9922 10.3879 10.407 9.99687L11.4406 4.31758ZM4.27383 6.34922C4.33398 6.16055 4.36953 5.96094 4.375 5.75586L9.40078 3.74609C9.49922 3.8418 9.60312 3.9293 9.71797 4.00586L8.68437 9.68242C8.53398 9.71797 8.38906 9.76719 8.25234 9.83281L4.27383 6.34922Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1283_17616",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "currentColor"
		})
	}) })]
});
export default SvgNavIconConnections;
